import { isValidElement } from 'react';

export const isReactNode = (value: unknown): value is React.ReactNode =>
  value === null ||
  value === undefined ||
  typeof value === 'string' ||
  typeof value === 'number' ||
  typeof value === 'boolean' ||
  isValidElement(value);
